import clsx from 'clsx';

export interface ColorSVGIconProps {
  color?: 'gray700' | 'gray400' | 'orange800' | 'orange400' | 'white' | 'dimmed';
  size?: number;
  rotate?: 0 | 90 | 180 | 270;
  className?: string;
  onClick?: (e: any) => void;
}

// 공통 SVG 설정 함수
const ColorSVGIconBase = ({
  size = 16,
  rotate = 0,
  className,
  onClick,
  children,
}: ColorSVGIconProps & { children: React.ReactNode }) => {
  return (
    <svg
      width={size}
      height={size}
      onClick={onClick}
      className={clsx(className, {
        'rotate-0': rotate === 0,
        'rotate-90': rotate === 90,
        'rotate-180': rotate === 180,
        '-rotate-90': rotate === 270,
      })}
      viewBox={`0 0 16 16`}
    >
      {children}
    </svg>
  );
};

const ReferenceIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M2 3C2 2.44772 2.44772 2 3 2H11C12.6569 2 14 3.34315 14 5V12C14 13.6569 12.6569 15 11 15H3C2.44772 15 2 14.5523 2 14V3Z"
            fill="#D8DBDF"
          />
          <path
            d="M7.5 1H4.5C4.22386 1 4 1.22386 4 1.5V5.5C4 5.70601 4.23519 5.82361 4.4 5.7L5.85 4.6125C5.93889 4.54583 6.06111 4.54583 6.15 4.6125L7.6 5.7C7.76481 5.82361 8 5.70601 8 5.5V1.5C8 1.22386 7.77614 1 7.5 1Z"
            fill="#61656B"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M2 3C2 2.44772 2.44772 2 3 2H11C12.6569 2 14 3.34315 14 5V12C14 13.6569 12.6569 15 11 15H3C2.44772 15 2 14.5523 2 14V3Z"
            fill="#E8EAED"
          />
          <path
            d="M7.5 1H4.5C4.22386 1 4 1.22386 4 1.5V5.5C4 5.70601 4.23519 5.82361 4.4 5.7L5.85 4.6125C5.93889 4.54583 6.06111 4.54583 6.15 4.6125L7.6 5.7C7.76481 5.82361 8 5.70601 8 5.5V1.5C8 1.22386 7.77614 1 7.5 1Z"
            fill="#898D94"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M2 3C2 2.44772 2.44772 2 3 2H11C12.6569 2 14 3.34315 14 5V12C14 13.6569 12.6569 15 11 15H3C2.44772 15 2 14.5523 2 14V3Z"
            fill="#FFD8C2"
          />
          <path
            d="M7.5 1H4.5C4.22386 1 4 1.22386 4 1.5V5.5C4 5.70601 4.23519 5.82361 4.4 5.7L5.85 4.6125C5.93889 4.54583 6.06111 4.54583 6.15 4.6125L7.6 5.7C7.76481 5.82361 8 5.70601 8 5.5V1.5C8 1.22386 7.77614 1 7.5 1Z"
            fill="#FF803D"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M2 3C2 2.44772 2.44772 2 3 2H11C12.6569 2 14 3.34315 14 5V12C14 13.6569 12.6569 15 11 15H3C2.44772 15 2 14.5523 2 14V3Z"
            fill="#E8EAED"
          />
          <path
            d="M7.5 1H4.5C4.22386 1 4 1.22386 4 1.5V5.5C4 5.70601 4.23519 5.82361 4.4 5.7L5.85 4.6125C5.93889 4.54583 6.06111 4.54583 6.15 4.6125L7.6 5.7C7.76481 5.82361 8 5.70601 8 5.5V1.5C8 1.22386 7.77614 1 7.5 1Z"
            fill="#FFFFFF"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};
const ProjectIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <rect x="2" y="2" width="12" height="13" rx="2" fill="#D8DBDF" />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="#898D94"
          />
          <path
            d="M9.75 10C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5L5.25 11.5C4.83579 11.5 4.5 11.1642 4.5 10.75C4.5 10.3358 4.83579 10 5.25 10L9.75 10Z"
            fill="#61656B"
          />
          <path
            d="M7.75 7C8.16421 7 8.5 7.33579 8.5 7.75C8.5 8.16421 8.16421 8.5 7.75 8.5L5.25 8.5C4.83579 8.5 4.5 8.16421 4.5 7.75C4.5 7.33579 4.83579 7 5.25 7L7.75 7Z"
            fill="#61656B"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <rect x="2" y="2" width="12" height="13" rx="2" fill="#E8EAED" />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="#C7CBD1"
          />
          <path
            d="M9.75 10C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5L5.25 11.5C4.83579 11.5 4.5 11.1642 4.5 10.75C4.5 10.3358 4.83579 10 5.25 10L9.75 10Z"
            fill="#898D94"
          />
          <path
            d="M7.75 7C8.16421 7 8.5 7.33579 8.5 7.75C8.5 8.16421 8.16421 8.5 7.75 8.5L5.25 8.5C4.83579 8.5 4.5 8.16421 4.5 7.75C4.5 7.33579 4.83579 7 5.25 7L7.75 7Z"
            fill="#898D94"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <rect x="2" y="2" width="12" height="13" rx="2" fill="#FFD8C2" />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="#FFBC99"
          />
          <path
            d="M9.75 10C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5L5.25 11.5C4.83579 11.5 4.5 11.1642 4.5 10.75C4.5 10.3358 4.83579 10 5.25 10L9.75 10Z"
            fill="#FF803D"
          />
          <path
            d="M7.75 7C8.16421 7 8.5 7.33579 8.5 7.75C8.5 8.16421 8.16421 8.5 7.75 8.5L5.25 8.5C4.83579 8.5 4.5 8.16421 4.5 7.75C4.5 7.33579 4.83579 7 5.25 7L7.75 7Z"
            fill="#FF803D"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M6 4H10C11.1046 4 12 3.10457 12 2C13.1046 2 14 2.89543 14 4V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2C4 3.10457 4.89543 4 6 4Z"
            fill="white"
          />
          <path
            d="M9.75 10C10.1642 10 10.5 10.3358 10.5 10.75C10.5 11.1642 10.1642 11.5 9.75 11.5L5.25 11.5C4.83579 11.5 4.5 11.1642 4.5 10.75C4.5 10.3358 4.83579 10 5.25 10L9.75 10Z"
            fill="#E8EAED"
          />
          <path
            d="M7.75 7C8.16421 7 8.5 7.33579 8.5 7.75C8.5 8.16421 8.16421 8.5 7.75 8.5L5.25 8.5C4.83579 8.5 4.5 8.16421 4.5 7.75C4.5 7.33579 4.83579 7 5.25 7L7.75 7Z"
            fill="#E8EAED"
          />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};
const NewIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="6" fill="#E8EAED" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.84281 5.71655C6.68001 5.52523 6.40643 5.45145 6.16052 5.53255C5.9146 5.61365 5.75 5.83194 5.75 6.07695V9.92305C5.75 10.2417 6.02473 10.5 6.36364 10.5C6.70254 10.5 6.97727 10.2417 6.97727 9.92305V7.72161L9.15719 10.2834C9.31999 10.4748 9.59357 10.5485 9.83948 10.4674C10.0854 10.3863 10.25 10.1681 10.25 9.92305V6.07695C10.25 5.75833 9.97527 5.50003 9.63636 5.50003C9.29746 5.50003 9.02273 5.75833 9.02273 6.07695V8.27839L6.84281 5.71655Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM6.16052 5.53255C6.40643 5.45145 6.68001 5.52523 6.84281 5.71655L9.02273 8.27839V6.07695C9.02273 5.75833 9.29746 5.50003 9.63636 5.50003C9.97527 5.50003 10.25 5.75833 10.25 6.07695V9.92305C10.25 10.1681 10.0854 10.3863 9.83948 10.4674C9.59357 10.5485 9.31999 10.4748 9.15719 10.2834L6.97727 7.72161V9.92305C6.97727 10.2417 6.70254 10.5 6.36364 10.5C6.02473 10.5 5.75 10.2417 5.75 9.92305V6.07695C5.75 5.83194 5.9146 5.61365 6.16052 5.53255Z"
            fill="#C7CBD1"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="6" fill="#FF600C" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.84281 5.71655C6.68001 5.52523 6.40643 5.45145 6.16052 5.53255C5.9146 5.61365 5.75 5.83194 5.75 6.07695V9.92305C5.75 10.2417 6.02473 10.5 6.36364 10.5C6.70254 10.5 6.97727 10.2417 6.97727 9.92305V7.72161L9.15719 10.2834C9.31999 10.4748 9.59357 10.5485 9.83948 10.4674C10.0854 10.3863 10.25 10.1681 10.25 9.92305V6.07695C10.25 5.75833 9.97527 5.50003 9.63636 5.50003C9.29746 5.50003 9.02273 5.75833 9.02273 6.07695V8.27839L6.84281 5.71655Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM6.16052 5.53255C6.40643 5.45145 6.68001 5.52523 6.84281 5.71655L9.02273 8.27839V6.07695C9.02273 5.75833 9.29746 5.50003 9.63636 5.50003C9.97527 5.50003 10.25 5.75833 10.25 6.07695V9.92305C10.25 10.1681 10.0854 10.3863 9.83948 10.4674C9.59357 10.5485 9.31999 10.4748 9.15719 10.2834L6.97727 7.72161V9.92305C6.97727 10.2417 6.70254 10.5 6.36364 10.5C6.02473 10.5 5.75 10.2417 5.75 9.92305V6.07695C5.75 5.83194 5.9146 5.61365 6.16052 5.53255Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const CloseIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM6.85355 6.14645C6.65829 5.95118 6.34171 5.95118 6.14645 6.14645C5.95118 6.34171 5.95118 6.65829 6.14645 6.85355L7.29289 8L6.14645 9.14645C5.95118 9.34171 5.95118 9.65829 6.14645 9.85355C6.34171 10.0488 6.65829 10.0488 6.85355 9.85355L8 8.70711L9.14645 9.85355C9.34171 10.0488 9.65829 10.0488 9.85355 9.85355C10.0488 9.65829 10.0488 9.34171 9.85355 9.14645L8.70711 8L9.85355 6.85355C10.0488 6.65829 10.0488 6.34171 9.85355 6.14645C9.65829 5.95118 9.34171 5.95118 9.14645 6.14645L8 7.29289L6.85355 6.14645Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="6" fill="#C7CBD1" />
          <path d="M6 10L8 8M8 8L10 6M8 8L6 6M8 8L10 10" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="6" fill="#FF600C" />
          <path d="M6 10L8 8M8 8L10 6M8 8L6 6M8 8L10 10" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM6.35355 5.64645C6.15829 5.45118 5.84171 5.45118 5.64645 5.64645C5.45118 5.84171 5.45118 6.15829 5.64645 6.35355L7.29289 8L5.64645 9.64645C5.45118 9.84171 5.45118 10.1583 5.64645 10.3536C5.84171 10.5488 6.15829 10.5488 6.35355 10.3536L8 8.70711L9.64645 10.3536C9.84171 10.5488 10.1583 10.5488 10.3536 10.3536C10.5488 10.1583 10.5488 9.84171 10.3536 9.64645L8.70711 8L10.3536 6.35355C10.5488 6.15829 10.5488 5.84171 10.3536 5.64645C10.1583 5.45118 9.84171 5.45118 9.64645 5.64645L8 7.29289L6.35355 5.64645Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    case 'dimmed':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="6" fill="black" fillOpacity="0.6" />
          <path
            d="M6.5 9.5L8 8M8 8L9.5 6.5M8 8L6.5 6.5M8 8L9.5 9.5"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const NightIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#D8DBDF" />
          <path
            d="M11.1243 9.53217C11.0649 9.53993 11.0086 9.54432 10.9489 9.54897C9.98488 9.6241 9.04979 9.34249 8.31748 8.75333C7.58517 8.16418 7.1445 7.33898 7.07409 6.4316C7.03393 5.91399 7.11779 5.40553 7.3113 4.93558C7.40931 4.70233 7.21839 4.43041 6.98078 4.51619C6.95954 4.52386 6.93838 4.53168 6.91728 4.53966C5.40263 5.12197 4.38529 6.57212 4.51038 8.1842C4.66476 10.1736 6.50264 11.6522 8.6163 11.4875C9.78577 11.3963 10.7911 10.8223 11.4332 9.99119C11.4358 9.9878 11.4384 9.9844 11.441 9.981C11.6025 9.7682 11.3893 9.50103 11.1243 9.53217Z"
            fill="#61656B"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#E8EAED" />
          <path
            d="M11.1243 9.53217C11.0649 9.53993 11.0086 9.54432 10.9489 9.54897C9.98488 9.6241 9.04979 9.34249 8.31748 8.75333C7.58517 8.16418 7.1445 7.33898 7.07409 6.4316C7.03393 5.91399 7.11779 5.40553 7.3113 4.93558C7.40931 4.70233 7.21839 4.43041 6.98078 4.51619C6.95954 4.52386 6.93838 4.53168 6.91728 4.53966C5.40263 5.12197 4.38529 6.57212 4.51038 8.1842C4.66476 10.1736 6.50264 11.6522 8.6163 11.4875C9.78577 11.3963 10.7911 10.8223 11.4332 9.99119C11.4358 9.9878 11.4384 9.9844 11.441 9.981C11.6025 9.7682 11.3893 9.50103 11.1243 9.53217Z"
            fill="#898D94"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#FFD8C2" />
          <path
            d="M11.1243 9.53217C11.0649 9.53993 11.0086 9.54432 10.9489 9.54897C9.98488 9.6241 9.04979 9.34249 8.31748 8.75333C7.58517 8.16418 7.1445 7.33898 7.07409 6.4316C7.03393 5.91399 7.11779 5.40553 7.3113 4.93558C7.40931 4.70233 7.21839 4.43041 6.98078 4.51619C6.95954 4.52386 6.93838 4.53168 6.91728 4.53966C5.40263 5.12197 4.38529 6.57212 4.51038 8.1842C4.66476 10.1736 6.50264 11.6522 8.6163 11.4875C9.78577 11.3963 10.7911 10.8223 11.4332 9.99119C11.4358 9.9878 11.4384 9.9844 11.441 9.981C11.6025 9.7682 11.3893 9.50103 11.1243 9.53217Z"
            fill="#FF803D"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.9489 9.54897C11.0086 9.54432 11.0649 9.53993 11.1243 9.53217C11.3893 9.50103 11.6025 9.7682 11.441 9.981L11.4332 9.99119C10.7911 10.8223 9.78577 11.3963 8.6163 11.4875C6.50264 11.6522 4.66476 10.1736 4.51038 8.1842C4.38529 6.57212 5.40263 5.12197 6.91728 4.53966C6.93838 4.53168 6.95954 4.52386 6.98078 4.51619C7.21839 4.43041 7.40931 4.70233 7.3113 4.93558C7.11779 5.40553 7.03393 5.91399 7.07409 6.4316C7.1445 7.33898 7.58517 8.16418 8.31748 8.75333C9.04979 9.34249 9.98488 9.6241 10.9489 9.54897Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const PinIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M7.40022 0.666667C7.40022 0.298477 7.66875 0 8 0C8.33125 0 8.59978 0.298477 8.59978 0.666667V15.3333C8.59978 15.7015 8.33125 16 8 16C7.66875 16 7.40022 15.7015 7.40022 15.3333V0.666667Z"
            fill="#4C5057"
          />
          <path
            d="M7.76009 2.31111C7.88004 2.48889 8.11996 2.48889 8.23991 2.31111L9.43948 0.533333C9.58775 0.313588 9.44669 0 9.19956 0H6.80044C6.55331 0 6.41225 0.313588 6.56052 0.533333L7.76009 2.31111Z"
            fill="#4C5057"
          />
          <path
            d="M7.76009 13.6889C7.88004 13.5111 8.11996 13.5111 8.23991 13.6889L9.43948 15.4667C9.58775 15.6864 9.44669 16 9.19956 16H6.80044C6.55331 16 6.41225 15.6864 6.56052 15.4667L7.76009 13.6889Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M7.40022 0.666667C7.40022 0.298477 7.66875 0 8 0C8.33125 0 8.59978 0.298477 8.59978 0.666667V15.3333C8.59978 15.7015 8.33125 16 8 16C7.66875 16 7.40022 15.7015 7.40022 15.3333V0.666667Z"
            fill="#C7CBD1"
          />
          <path
            d="M7.76009 2.31111C7.88004 2.48889 8.11996 2.48889 8.23991 2.31111L9.43948 0.533333C9.58775 0.313588 9.44669 0 9.19956 0H6.80044C6.55331 0 6.41225 0.313588 6.56052 0.533333L7.76009 2.31111Z"
            fill="#C7CBD1"
          />
          <path
            d="M7.76009 13.6889C7.88004 13.5111 8.11996 13.5111 8.23991 13.6889L9.43948 15.4667C9.58775 15.6864 9.44669 16 9.19956 16H6.80044C6.55331 16 6.41225 15.6864 6.56052 15.4667L7.76009 13.6889Z"
            fill="#C7CBD1"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M7.40022 0.666667C7.40022 0.298477 7.66875 0 8 0C8.33125 0 8.59978 0.298477 8.59978 0.666667V15.3333C8.59978 15.7015 8.33125 16 8 16C7.66875 16 7.40022 15.7015 7.40022 15.3333V0.666667Z"
            fill="#FF600C"
          />
          <path
            d="M7.76009 2.31111C7.88004 2.48889 8.11996 2.48889 8.23991 2.31111L9.43948 0.533333C9.58775 0.313588 9.44669 0 9.19956 0H6.80044C6.55331 0 6.41225 0.313588 6.56052 0.533333L7.76009 2.31111Z"
            fill="#FF600C"
          />
          <path
            d="M7.76009 13.6889C7.88004 13.5111 8.11996 13.5111 8.23991 13.6889L9.43948 15.4667C9.58775 15.6864 9.44669 16 9.19956 16H6.80044C6.55331 16 6.41225 15.6864 6.56052 15.4667L7.76009 13.6889Z"
            fill="#FF600C"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            d="M7.40022 0.666667C7.40022 0.298477 7.66875 0 8 0C8.33125 0 8.59978 0.298477 8.59978 0.666667V15.3333C8.59978 15.7015 8.33125 16 8 16C7.66875 16 7.40022 15.7015 7.40022 15.3333V0.666667Z"
            fill="white"
          />
          <path
            d="M7.76009 2.31111C7.88004 2.48889 8.11996 2.48889 8.23991 2.31111L9.43948 0.533333C9.58775 0.313588 9.44669 0 9.19956 0H6.80044C6.55331 0 6.41225 0.313588 6.56052 0.533333L7.76009 2.31111Z"
            fill="white"
          />
          <path
            d="M7.76009 13.6889C7.88004 13.5111 8.11996 13.5111 8.23991 13.6889L9.43948 15.4667C9.58775 15.6864 9.44669 16 9.19956 16H6.80044C6.55331 16 6.41225 15.6864 6.56052 15.4667L7.76009 13.6889Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};
const ProfileIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#D8DBDF" />
          <path
            d="M10.1 6.5C10.1 7.60457 9.1598 8.5 8 8.5C6.8402 8.5 5.9 7.60457 5.9 6.5C5.9 5.39543 6.8402 4.5 8 4.5C9.1598 4.5 10.1 5.39543 10.1 6.5Z"
            fill="#4C5057"
          />
          <path
            d="M8 8.5C6.43813 8.5 5.1152 9.25671 4.66479 10.5184C4.47911 11.0386 4.94772 11.5 5.5 11.5H10.5C11.0523 11.5 11.5209 11.0386 11.3352 10.5184C10.8848 9.25671 9.56187 8.5 8 8.5Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#E8EAED" />
          <path
            d="M10.1 6.5C10.1 7.60457 9.1598 8.5 8 8.5C6.8402 8.5 5.9 7.60457 5.9 6.5C5.9 5.39543 6.8402 4.5 8 4.5C9.1598 4.5 10.1 5.39543 10.1 6.5Z"
            fill="#898D94"
          />
          <path
            d="M8 8.5C6.43813 8.5 5.1152 9.25671 4.66479 10.5184C4.47911 11.0386 4.94772 11.5 5.5 11.5H10.5C11.0523 11.5 11.5209 11.0386 11.3352 10.5184C10.8848 9.25671 9.56187 8.5 8 8.5Z"
            fill="#898D94"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#FFD8C2" />
          <path
            d="M10.1 6.5C10.1 7.60457 9.1598 8.5 8 8.5C6.8402 8.5 5.9 7.60457 5.9 6.5C5.9 5.39543 6.8402 4.5 8 4.5C9.1598 4.5 10.1 5.39543 10.1 6.5Z"
            fill="#FF600C"
          />
          <path
            d="M8 8.5C6.43813 8.5 5.1152 9.25671 4.66479 10.5184C4.47911 11.0386 4.94772 11.5 5.5 11.5H10.5C11.0523 11.5 11.5209 11.0386 11.3352 10.5184C10.8848 9.25671 9.56187 8.5 8 8.5Z"
            fill="#FF600C"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="white" />
          <path
            d="M10.1 6.5C10.1 7.60457 9.1598 8.5 8 8.5C6.8402 8.5 5.9 7.60457 5.9 6.5C5.9 5.39543 6.8402 4.5 8 4.5C9.1598 4.5 10.1 5.39543 10.1 6.5Z"
            fill="#E8EAED"
          />
          <path
            d="M8 8.5C6.43813 8.5 5.1152 9.25671 4.66479 10.5184C4.47911 11.0386 4.94772 11.5 5.5 11.5H10.5C11.0523 11.5 11.5209 11.0386 11.3352 10.5184C10.8848 9.25671 9.56187 8.5 8 8.5Z"
            fill="#E8EAED"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const ArrowIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', rotate = 0, ...props }) => {
  let fillColor;
  switch (color) {
    case 'gray700':
      fillColor = '#4C5057';
      break;
    case 'gray400':
      fillColor = '#C7CBD1';
      break;
    case 'orange800':
      fillColor = '#FF600C';
      break;
    case 'orange400':
      fillColor = '#FFBC99';
      break;
    case 'white':
      fillColor = 'white';
      break;
    default:
      fillColor = '#4C5057';
  }

  return (
    <ColorSVGIconBase rotate={rotate} {...props}>
      <path
        d="M11 5.0364V10.9636C11 11.8406 9.90894 12.3197 9.19029 11.7583L5.39701 8.79467C4.86767 8.38111 4.86766 7.61889 5.397 7.20533L9.19029 4.24174C9.90894 3.68028 11 4.15938 11 5.0364Z"
        fill={fillColor}
      />
    </ColorSVGIconBase>
  );
};

const TalkIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', rotate = 0, ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M14.2492 6.3001C14.2492 5.63736 13.712 5.1001 13.0492 5.1001H8.64922C7.98648 5.1001 7.44922 5.63736 7.44922 6.3001V11.3001C7.44922 11.9628 7.98648 12.5001 8.64922 12.5001H13.0492C13.712 12.5001 14.2492 11.9628 14.2492 11.3001V6.3001Z"
            fill="#C7CBD1"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M13.05 13.8173V11.9001H10.65L12.7086 13.9587C12.8346 14.0847 13.05 13.9954 13.05 13.8173Z"
            fill="#C7CBD1"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M1.75 3.5C1.75 2.67157 2.42157 2 3.25 2H11.25C12.0784 2 12.75 2.67157 12.75 3.5V9.5C12.75 10.3284 12.0784 11 11.25 11H3.25C2.42157 11 1.75 10.3284 1.75 9.5V3.5Z"
            fill="#61656B"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M3.75 12.2V10H7.75L4.39 12.52C4.12631 12.7178 3.75 12.5296 3.75 12.2Z"
            fill="#61656B"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M5.5 6.5C5.5 6.91421 5.16421 7.25 4.75 7.25C4.33579 7.25 4 6.91421 4 6.5C4 6.08579 4.33579 5.75 4.75 5.75C5.16421 5.75 5.5 6.08579 5.5 6.5Z"
            fill="white"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M8 6.5C8 6.91421 7.66421 7.25 7.25 7.25C6.83579 7.25 6.5 6.91421 6.5 6.5C6.5 6.08579 6.83579 5.75 7.25 5.75C7.66421 5.75 8 6.08579 8 6.5Z"
            fill="white"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M10.5 6.5C10.5 6.91421 10.1642 7.25 9.75 7.25C9.33579 7.25 9 6.91421 9 6.5C9 6.08579 9.33579 5.75 9.75 5.75C10.1642 5.75 10.5 6.08579 10.5 6.5Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M14.2492 6.3001C14.2492 5.63736 13.712 5.1001 13.0492 5.1001H8.64922C7.98648 5.1001 7.44922 5.63736 7.44922 6.3001V11.3001C7.44922 11.9628 7.98648 12.5001 8.64922 12.5001H13.0492C13.712 12.5001 14.2492 11.9628 14.2492 11.3001V6.3001Z"
            fill="#C7CBD1"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M13.05 13.8173V11.9001H10.65L12.7086 13.9587C12.8346 14.0847 13.05 13.9954 13.05 13.8173Z"
            fill="#C7CBD1"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M1.75 3.5C1.75 2.67157 2.42157 2 3.25 2H11.25C12.0784 2 12.75 2.67157 12.75 3.5V9.5C12.75 10.3284 12.0784 11 11.25 11H3.25C2.42157 11 1.75 10.3284 1.75 9.5V3.5Z"
            fill="#E8EAED"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M3.75 12.2V10H7.75L4.39 12.52C4.12631 12.7178 3.75 12.5296 3.75 12.2Z"
            fill="#E8EAED"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M5.5 6.5C5.5 6.91421 5.16421 7.25 4.75 7.25C4.33579 7.25 4 6.91421 4 6.5C4 6.08579 4.33579 5.75 4.75 5.75C5.16421 5.75 5.5 6.08579 5.5 6.5Z"
            fill="#61656B"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M8 6.5C8 6.91421 7.66421 7.25 7.25 7.25C6.83579 7.25 6.5 6.91421 6.5 6.5C6.5 6.08579 6.83579 5.75 7.25 5.75C7.66421 5.75 8 6.08579 8 6.5Z"
            fill="#61656B"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M10.5 6.5C10.5 6.91421 10.1642 7.25 9.75 7.25C9.33579 7.25 9 6.91421 9 6.5C9 6.08579 9.33579 5.75 9.75 5.75C10.1642 5.75 10.5 6.08579 10.5 6.5Z"
            fill="#61656B"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M14.2492 6.3001C14.2492 5.63736 13.712 5.1001 13.0492 5.1001H8.64922C7.98648 5.1001 7.44922 5.63736 7.44922 6.3001V11.3001C7.44922 11.9628 7.98648 12.5001 8.64922 12.5001H13.0492C13.712 12.5001 14.2492 11.9628 14.2492 11.3001V6.3001Z"
            fill="#FFD8C2"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M13.05 13.8173V11.9001H10.65L12.7086 13.9587C12.8346 14.0847 13.05 13.9954 13.05 13.8173Z"
            fill="#FFD8C2"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M1.75 3.5C1.75 2.67157 2.42157 2 3.25 2H11.25C12.0784 2 12.75 2.67157 12.75 3.5V9.5C12.75 10.3284 12.0784 11 11.25 11H3.25C2.42157 11 1.75 10.3284 1.75 9.5V3.5Z"
            fill="#FF803D"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M3.75 12.2V10H7.75L4.39 12.52C4.12631 12.7178 3.75 12.5296 3.75 12.2Z"
            fill="#FF803D"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M5.5 6.5C5.5 6.91421 5.16421 7.25 4.75 7.25C4.33579 7.25 4 6.91421 4 6.5C4 6.08579 4.33579 5.75 4.75 5.75C5.16421 5.75 5.5 6.08579 5.5 6.5Z"
            fill="white"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M8 6.5C8 6.91421 7.66421 7.25 7.25 7.25C6.83579 7.25 6.5 6.91421 6.5 6.5C6.5 6.08579 6.83579 5.75 7.25 5.75C7.66421 5.75 8 6.08579 8 6.5Z"
            fill="white"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M10.5 6.5C10.5 6.91421 10.1642 7.25 9.75 7.25C9.33579 7.25 9 6.91421 9 6.5C9 6.08579 9.33579 5.75 9.75 5.75C10.1642 5.75 10.5 6.08579 10.5 6.5Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M14.2492 6.3001C14.2492 5.63736 13.712 5.1001 13.0492 5.1001H11V8.5H9H8H7.44922V11.3001C7.44922 11.9628 7.98648 12.5001 8.64922 12.5001H13.0492C13.712 12.5001 14.2492 11.9628 14.2492 11.3001V6.3001Z"
            fill="#D8DBDF"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M13.05 13.8173V11.9001H10.65L12.7086 13.9587C12.8346 14.0847 13.05 13.9954 13.05 13.8173Z"
            fill="#D8DBDF"
          />
          <path
            xmlns="http://www.w3.org/2000/svg"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.25 2C2.42157 2 1.75 2.67157 1.75 3.5V9.5C1.75 10.3284 2.42157 11 3.25 11H3.75V12.2C3.75 12.5296 4.12631 12.7178 4.39 12.52L6.41667 11H11.25C12.0784 11 12.75 10.3284 12.75 9.5V3.5C12.75 2.67157 12.0784 2 11.25 2H3.25ZM4.75 7.25C5.16421 7.25 5.5 6.91421 5.5 6.5C5.5 6.08579 5.16421 5.75 4.75 5.75C4.33579 5.75 4 6.08579 4 6.5C4 6.91421 4.33579 7.25 4.75 7.25ZM8 6.5C8 6.91421 7.66421 7.25 7.25 7.25C6.83579 7.25 6.5 6.91421 6.5 6.5C6.5 6.08579 6.83579 5.75 7.25 5.75C7.66421 5.75 8 6.08579 8 6.5ZM9.75 7.25C10.1642 7.25 10.5 6.91421 10.5 6.5C10.5 6.08579 10.1642 5.75 9.75 5.75C9.33579 5.75 9 6.08579 9 6.5C9 6.91421 9.33579 7.25 9.75 7.25Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};
const TooltipIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', rotate = 0, ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#D8DBDF" />
          <path
            d="M6.03039 5.70404C6.31596 5.08618 7.03403 4.7002 7.98877 4.7002C8.61701 4.7002 9.14544 4.87742 9.51632 5.18314C9.88683 5.48855 10.1004 5.92228 10.1004 6.43791C10.1004 6.78751 10.013 7.08171 9.84751 7.33493C9.68183 7.58846 9.43693 7.80193 9.12187 7.98818C8.81773 8.16336 8.62663 8.30726 8.50702 8.46106C8.38746 8.61481 8.34007 8.77744 8.32105 8.98772L8.3203 8.99396C8.29717 9.14226 8.24725 9.26073 8.16603 9.34245C8.08419 9.4248 7.9687 9.47168 7.81219 9.47168C7.63747 9.47168 7.50358 9.41005 7.41357 9.30899C7.32363 9.208 7.27586 9.06583 7.27586 8.90088V8.81325C7.27586 8.53064 7.34694 8.29655 7.4896 8.09068C7.63243 7.88458 7.84836 7.70552 8.13765 7.53543L8.13883 7.53472C8.42652 7.36193 8.62095 7.21115 8.74337 7.047C8.86649 6.88189 8.91621 6.70408 8.91621 6.47942C8.91621 6.22281 8.8152 6.00512 8.6421 5.85208C8.46936 5.69935 8.22518 5.61118 7.93766 5.61118C7.67831 5.61118 7.46127 5.67496 7.28996 5.79825C7.11842 5.9217 6.99344 6.10434 6.91811 6.34032L6.91773 6.34137C6.86746 6.4813 6.80064 6.57831 6.71596 6.64065C6.63079 6.70335 6.52621 6.73197 6.39955 6.73197C6.2406 6.73197 6.11583 6.68387 6.03112 6.5998C5.94677 6.51607 5.90039 6.39496 5.90039 6.24419C5.90039 6.04987 5.94115 5.88277 6.02724 5.71085L6.03039 5.70404Z"
            fill="#4C5057"
          />
          <path
            d="M7.30039 10.7983C7.30039 10.4631 7.56918 10.2002 7.90222 10.2002C8.2358 10.2002 8.50039 10.4636 8.50039 10.7983C8.50039 11.1325 8.23635 11.4002 7.90222 11.4002C7.56862 11.4002 7.30039 11.133 7.30039 10.7983Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#E8EAED" />
          <path
            d="M6.03039 5.70404C6.31596 5.08618 7.03403 4.7002 7.98877 4.7002C8.61701 4.7002 9.14544 4.87742 9.51632 5.18314C9.88683 5.48855 10.1004 5.92228 10.1004 6.43791C10.1004 6.78751 10.013 7.08171 9.84751 7.33493C9.68183 7.58846 9.43693 7.80193 9.12187 7.98818C8.81773 8.16336 8.62663 8.30726 8.50702 8.46106C8.38746 8.61481 8.34007 8.77744 8.32105 8.98772L8.3203 8.99396C8.29717 9.14226 8.24725 9.26073 8.16603 9.34245C8.08419 9.4248 7.9687 9.47168 7.81219 9.47168C7.63747 9.47168 7.50358 9.41005 7.41357 9.30899C7.32363 9.208 7.27586 9.06583 7.27586 8.90088V8.81325C7.27586 8.53064 7.34694 8.29655 7.4896 8.09068C7.63243 7.88458 7.84836 7.70552 8.13765 7.53543L8.13883 7.53472C8.42652 7.36193 8.62095 7.21115 8.74337 7.047C8.86649 6.88189 8.91621 6.70408 8.91621 6.47942C8.91621 6.22281 8.8152 6.00512 8.6421 5.85208C8.46936 5.69935 8.22518 5.61118 7.93766 5.61118C7.67831 5.61118 7.46127 5.67496 7.28996 5.79825C7.11842 5.9217 6.99344 6.10434 6.91811 6.34032L6.91773 6.34137C6.86746 6.4813 6.80064 6.57831 6.71596 6.64065C6.63079 6.70335 6.52621 6.73197 6.39955 6.73197C6.2406 6.73197 6.11583 6.68387 6.03112 6.5998C5.94677 6.51607 5.90039 6.39496 5.90039 6.24419C5.90039 6.04987 5.94115 5.88277 6.02724 5.71085L6.03039 5.70404Z"
            fill="#C7CBD1"
          />
          <path
            d="M7.30039 10.7983C7.30039 10.4631 7.56918 10.2002 7.90222 10.2002C8.2358 10.2002 8.50039 10.4636 8.50039 10.7983C8.50039 11.1325 8.23635 11.4002 7.90222 11.4002C7.56862 11.4002 7.30039 11.133 7.30039 10.7983Z"
            fill="#C7CBD1"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="#FFD8C2" />
          <path
            d="M6.03039 5.70404C6.31596 5.08618 7.03403 4.7002 7.98877 4.7002C8.61701 4.7002 9.14544 4.87742 9.51632 5.18314C9.88683 5.48855 10.1004 5.92228 10.1004 6.43791C10.1004 6.78751 10.013 7.08171 9.84751 7.33493C9.68183 7.58846 9.43693 7.80193 9.12187 7.98818C8.81773 8.16336 8.62663 8.30726 8.50702 8.46106C8.38746 8.61481 8.34007 8.77744 8.32105 8.98772L8.3203 8.99396C8.29717 9.14226 8.24725 9.26073 8.16603 9.34245C8.08419 9.4248 7.9687 9.47168 7.81219 9.47168C7.63747 9.47168 7.50358 9.41005 7.41357 9.30899C7.32363 9.208 7.27586 9.06583 7.27586 8.90088V8.81325C7.27586 8.53064 7.34694 8.29655 7.4896 8.09068C7.63243 7.88458 7.84836 7.70552 8.13765 7.53543L8.13883 7.53472C8.42652 7.36193 8.62095 7.21115 8.74337 7.047C8.86649 6.88189 8.91621 6.70408 8.91621 6.47942C8.91621 6.22281 8.8152 6.00512 8.6421 5.85208C8.46936 5.69935 8.22518 5.61118 7.93766 5.61118C7.67831 5.61118 7.46127 5.67496 7.28996 5.79825C7.11842 5.9217 6.99344 6.10434 6.91811 6.34032L6.91773 6.34137C6.86746 6.4813 6.80064 6.57831 6.71596 6.64065C6.63079 6.70335 6.52621 6.73197 6.39955 6.73197C6.2406 6.73197 6.11583 6.68387 6.03112 6.5998C5.94677 6.51607 5.90039 6.39496 5.90039 6.24419C5.90039 6.04987 5.94115 5.88277 6.02724 5.71085L6.03039 5.70404Z"
            fill="#FF600C"
          />
          <path
            d="M7.30039 10.7983C7.30039 10.4631 7.56918 10.2002 7.90222 10.2002C8.2358 10.2002 8.50039 10.4636 8.50039 10.7983C8.50039 11.1325 8.23635 11.4002 7.90222 11.4002C7.56862 11.4002 7.30039 11.133 7.30039 10.7983Z"
            fill="#FF600C"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <circle cx="8" cy="8" r="7" fill="white" />
          <path
            d="M6.03039 5.70404C6.31596 5.08618 7.03403 4.7002 7.98877 4.7002C8.61701 4.7002 9.14544 4.87742 9.51632 5.18314C9.88683 5.48855 10.1004 5.92228 10.1004 6.43791C10.1004 6.78751 10.013 7.08171 9.84751 7.33493C9.68183 7.58846 9.43693 7.80193 9.12187 7.98818C8.81773 8.16336 8.62663 8.30726 8.50702 8.46106C8.38746 8.61481 8.34007 8.77744 8.32105 8.98772L8.3203 8.99396C8.29717 9.14226 8.24725 9.26073 8.16603 9.34245C8.08419 9.4248 7.9687 9.47168 7.81219 9.47168C7.63747 9.47168 7.50358 9.41005 7.41357 9.30899C7.32363 9.208 7.27586 9.06583 7.27586 8.90088V8.81325C7.27586 8.53064 7.34694 8.29655 7.4896 8.09068C7.63243 7.88458 7.84836 7.70552 8.13765 7.53543L8.13883 7.53472C8.42652 7.36193 8.62095 7.21115 8.74337 7.047C8.86649 6.88189 8.91621 6.70408 8.91621 6.47942C8.91621 6.22281 8.8152 6.00512 8.6421 5.85208C8.46936 5.69935 8.22518 5.61118 7.93766 5.61118C7.67831 5.61118 7.46127 5.67496 7.28996 5.79825C7.11842 5.9217 6.99344 6.10434 6.91811 6.34032L6.91773 6.34137C6.86746 6.4813 6.80064 6.57831 6.71596 6.64065C6.63079 6.70335 6.52621 6.73197 6.39955 6.73197C6.2406 6.73197 6.11583 6.68387 6.03112 6.5998C5.94677 6.51607 5.90039 6.39496 5.90039 6.24419C5.90039 6.04987 5.94115 5.88277 6.02724 5.71085L6.03039 5.70404Z"
            fill="#E8EAED"
          />
          <path
            d="M7.30039 10.7983C7.30039 10.4631 7.56918 10.2002 7.90222 10.2002C8.2358 10.2002 8.50039 10.4636 8.50039 10.7983C8.50039 11.1325 8.23635 11.4002 7.90222 11.4002C7.56862 11.4002 7.30039 11.133 7.30039 10.7983Z"
            fill="#E8EAED"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const TooltipBoldIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', rotate = 0, ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.03799 4.3999C7.05958 4.3999 6.29634 4.79648 5.98883 5.46179L5.987 5.46576C5.89411 5.65126 5.84961 5.83367 5.84961 6.0439C5.84961 6.21537 5.90279 6.36417 6.0099 6.47048C6.11731 6.57709 6.2696 6.63168 6.44876 6.63168C6.59081 6.63168 6.71788 6.59936 6.82447 6.52089C6.92997 6.44322 7.00657 6.32683 7.06129 6.17423L7.0626 6.17044C7.1326 5.95114 7.24641 5.78793 7.39759 5.67912C7.54868 5.57038 7.74418 5.51089 7.98688 5.51089C8.25413 5.51089 8.4735 5.59268 8.62508 5.7267C8.7761 5.86023 8.86543 6.05035 8.86543 6.27913C8.86543 6.48667 8.82025 6.64233 8.71242 6.78692C8.60199 6.935 8.42135 7.07766 8.13656 7.2487L8.13538 7.24941C7.83921 7.42355 7.61075 7.61102 7.45662 7.83343C7.3013 8.05756 7.22508 8.31194 7.22508 8.61295V8.70059C7.22508 8.88422 7.27835 9.05196 7.38811 9.1752C7.49929 9.30004 7.66164 9.37139 7.86141 9.37139C8.03918 9.37139 8.18209 9.31738 8.28617 9.21265C8.38772 9.11048 8.44367 8.9687 8.4686 8.80733L8.46974 8.79789C8.48761 8.59856 8.53097 8.45617 8.63518 8.32216C8.74244 8.18422 8.91952 8.04817 9.22116 7.87445L9.2224 7.87373C9.54638 7.6822 9.80402 7.4593 9.98044 7.18934C10.1574 6.91858 10.2496 6.60506 10.2496 6.23762C10.2496 5.69203 10.0226 5.23004 9.62915 4.90569C9.23681 4.58228 8.68439 4.3999 8.03799 4.3999ZM7.8558 10.1245C7.4395 10.1245 7.10352 10.4531 7.10352 10.8722C7.10352 11.2905 7.4388 11.6245 7.8558 11.6245C8.27347 11.6245 8.60352 11.2898 8.60352 10.8722C8.60352 10.4538 8.27277 10.1245 7.8558 10.1245Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.03799 4.3999C7.05958 4.3999 6.29634 4.79648 5.98883 5.46179L5.987 5.46576C5.89411 5.65126 5.84961 5.83367 5.84961 6.0439C5.84961 6.21537 5.90279 6.36417 6.0099 6.47048C6.11731 6.57709 6.2696 6.63168 6.44876 6.63168C6.59081 6.63168 6.71788 6.59936 6.82447 6.52089C6.92997 6.44322 7.00657 6.32683 7.06129 6.17423L7.0626 6.17044C7.1326 5.95114 7.24641 5.78793 7.39759 5.67912C7.54868 5.57038 7.74418 5.51089 7.98688 5.51089C8.25413 5.51089 8.4735 5.59268 8.62508 5.7267C8.7761 5.86023 8.86543 6.05035 8.86543 6.27913C8.86543 6.48667 8.82025 6.64233 8.71242 6.78692C8.60199 6.935 8.42135 7.07766 8.13656 7.2487L8.13538 7.24941C7.83921 7.42355 7.61075 7.61102 7.45662 7.83343C7.3013 8.05756 7.22508 8.31194 7.22508 8.61295V8.70059C7.22508 8.88422 7.27835 9.05196 7.38811 9.1752C7.49929 9.30004 7.66164 9.37139 7.86141 9.37139C8.03918 9.37139 8.18209 9.31738 8.28617 9.21265C8.38772 9.11048 8.44367 8.9687 8.4686 8.80733L8.46974 8.79789C8.48761 8.59856 8.53097 8.45617 8.63518 8.32216C8.74244 8.18422 8.91952 8.04817 9.22116 7.87445L9.2224 7.87373C9.54638 7.6822 9.80402 7.4593 9.98044 7.18934C10.1574 6.91858 10.2496 6.60506 10.2496 6.23762C10.2496 5.69203 10.0226 5.23004 9.62915 4.90569C9.23681 4.58228 8.68439 4.3999 8.03799 4.3999ZM7.8558 10.1245C7.4395 10.1245 7.10352 10.4531 7.10352 10.8722C7.10352 11.2905 7.4388 11.6245 7.8558 11.6245C8.27347 11.6245 8.60352 11.2898 8.60352 10.8722C8.60352 10.4538 8.27277 10.1245 7.8558 10.1245Z"
            fill="#C7CBD1"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.03799 4.3999C7.05958 4.3999 6.29634 4.79648 5.98883 5.46179L5.987 5.46576C5.89411 5.65126 5.84961 5.83367 5.84961 6.0439C5.84961 6.21537 5.90279 6.36417 6.0099 6.47048C6.11731 6.57709 6.2696 6.63168 6.44876 6.63168C6.59081 6.63168 6.71788 6.59936 6.82447 6.52089C6.92997 6.44322 7.00657 6.32683 7.06129 6.17423L7.0626 6.17044C7.1326 5.95114 7.24641 5.78793 7.39759 5.67912C7.54868 5.57038 7.74418 5.51089 7.98688 5.51089C8.25413 5.51089 8.4735 5.59268 8.62508 5.7267C8.7761 5.86023 8.86543 6.05035 8.86543 6.27913C8.86543 6.48667 8.82025 6.64233 8.71242 6.78692C8.60199 6.935 8.42135 7.07766 8.13656 7.2487L8.13538 7.24941C7.83921 7.42355 7.61075 7.61102 7.45662 7.83343C7.3013 8.05756 7.22508 8.31194 7.22508 8.61295V8.70059C7.22508 8.88422 7.27835 9.05196 7.38811 9.1752C7.49929 9.30004 7.66164 9.37139 7.86141 9.37139C8.03918 9.37139 8.18209 9.31738 8.28617 9.21265C8.38772 9.11048 8.44367 8.9687 8.4686 8.80733L8.46974 8.79789C8.48761 8.59856 8.53097 8.45617 8.63518 8.32216C8.74244 8.18422 8.91952 8.04817 9.22116 7.87445L9.2224 7.87373C9.54638 7.6822 9.80402 7.4593 9.98044 7.18934C10.1574 6.91858 10.2496 6.60506 10.2496 6.23762C10.2496 5.69203 10.0226 5.23004 9.62915 4.90569C9.23681 4.58228 8.68439 4.3999 8.03799 4.3999ZM7.8558 10.1245C7.4395 10.1245 7.10352 10.4531 7.10352 10.8722C7.10352 11.2905 7.4388 11.6245 7.8558 11.6245C8.27347 11.6245 8.60352 11.2898 8.60352 10.8722C8.60352 10.4538 8.27277 10.1245 7.8558 10.1245Z"
            fill="#FF600C"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase {...props}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8.03799 4.3999C7.05958 4.3999 6.29634 4.79648 5.98883 5.46179L5.987 5.46576C5.89411 5.65126 5.84961 5.83367 5.84961 6.0439C5.84961 6.21537 5.90279 6.36417 6.0099 6.47048C6.11731 6.57709 6.2696 6.63168 6.44876 6.63168C6.59081 6.63168 6.71788 6.59936 6.82447 6.52089C6.92997 6.44322 7.00657 6.32683 7.06129 6.17423L7.0626 6.17044C7.1326 5.95114 7.24641 5.78793 7.39759 5.67912C7.54868 5.57038 7.74418 5.51089 7.98688 5.51089C8.25413 5.51089 8.4735 5.59268 8.62508 5.7267C8.7761 5.86023 8.86543 6.05035 8.86543 6.27913C8.86543 6.48667 8.82025 6.64233 8.71242 6.78692C8.60199 6.935 8.42135 7.07766 8.13656 7.2487L8.13538 7.24941C7.83921 7.42355 7.61075 7.61102 7.45662 7.83343C7.3013 8.05756 7.22508 8.31194 7.22508 8.61295V8.70059C7.22508 8.88422 7.27835 9.05196 7.38811 9.1752C7.49929 9.30004 7.66164 9.37139 7.86141 9.37139C8.03918 9.37139 8.18209 9.31738 8.28617 9.21265C8.38772 9.11048 8.44367 8.9687 8.4686 8.80733L8.46974 8.79789C8.48761 8.59856 8.53097 8.45617 8.63518 8.32216C8.74244 8.18422 8.91952 8.04817 9.22116 7.87445L9.2224 7.87373C9.54638 7.6822 9.80402 7.4593 9.98044 7.18934C10.1574 6.91858 10.2496 6.60506 10.2496 6.23762C10.2496 5.69203 10.0226 5.23004 9.62915 4.90569C9.23681 4.58228 8.68439 4.3999 8.03799 4.3999ZM7.8558 10.1245C7.4395 10.1245 7.10352 10.4531 7.10352 10.8722C7.10352 11.2905 7.4388 11.6245 7.8558 11.6245C8.27347 11.6245 8.60352 11.2898 8.60352 10.8722C8.60352 10.4538 8.27277 10.1245 7.8558 10.1245Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const CopyCheckIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2" width="12" height="13" rx="2" fill="#D8DBDF" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0103 6.45041C11.3139 6.73226 11.3315 7.20681 11.0496 7.51034L8.16599 10.6158C7.67146 11.1483 6.82855 11.1483 6.33401 10.6158L4.95041 9.12573C4.66856 8.82219 4.68613 8.34764 4.98966 8.06579C5.2932 7.78394 5.76775 7.80152 6.0496 8.10505L7.25 9.39779L9.95041 6.48966C10.2323 6.18613 10.7068 6.16856 11.0103 6.45041Z"
            fill="#61656B"
          />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="#898D94"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2" width="12" height="13" rx="2" fill="#E8EAED" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0103 6.45041C11.3139 6.73226 11.3315 7.20681 11.0496 7.51034L8.16599 10.6158C7.67146 11.1483 6.82855 11.1483 6.33401 10.6158L4.95041 9.12573C4.66856 8.82219 4.68613 8.34764 4.98966 8.06579C5.2932 7.78394 5.76775 7.80152 6.0496 8.10505L7.25 9.39779L9.95041 6.48966C10.2323 6.18613 10.7068 6.16856 11.0103 6.45041Z"
            fill="#898D94"
          />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="#C7CBD1"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2" width="12" height="13" rx="2" fill="#FFD8C2" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0103 6.45041C11.3139 6.73226 11.3315 7.20681 11.0496 7.51034L8.16599 10.6158C7.67146 11.1483 6.82855 11.1483 6.33401 10.6158L4.95041 9.12573C4.66856 8.82219 4.68613 8.34764 4.98966 8.06579C5.2932 7.78394 5.76775 7.80152 6.0496 8.10505L7.25 9.39779L9.95041 6.48966C10.2323 6.18613 10.7068 6.16856 11.0103 6.45041Z"
            fill="#FF803D"
          />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="#FFBC99"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <path
            d="M6 4H10C11.1046 4 12 3.10457 12 2C13.1046 2 14 2.89543 14 4V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2C4 3.10457 4.89543 4 6 4Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0103 6.45041C11.3139 6.73226 11.3315 7.20681 11.0496 7.51034L8.16599 10.6158C7.67146 11.1483 6.82855 11.1483 6.33401 10.6158L4.95041 9.12573C4.66856 8.82219 4.68613 8.34764 4.98966 8.06579C5.2932 7.78394 5.76775 7.80152 6.0496 8.10505L7.25 9.39779L9.95041 6.48966C10.2323 6.18613 10.7068 6.16856 11.0103 6.45041Z"
            fill="#E8EAED"
          />
          <path
            d="M10 1C10.5523 1 11 1.44772 11 2C11 2.55228 10.5523 3 10 3L6 3C5.44772 3 5 2.55228 5 2C5 1.44772 5.44772 1 6 1L10 1Z"
            fill="white"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const CalendarIcon: React.FC<ColorSVGIconProps> = ({ color = 'gray700', ...props }) => {
  switch (color) {
    case 'gray700':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2.25" width="12" height="12" rx="1.5" fill="#E8EAED" />
          <path
            d="M6 1.75C6 1.47386 5.77614 1.25 5.5 1.25C5.22386 1.25 5 1.47386 5 1.75V2.25H3.5C2.67157 2.25 2 2.94324 2 3.79839V6.81445H14V3.79839C14 2.94324 13.3284 2.25 12.5 2.25H11V1.75C11 1.47386 10.7761 1.25 10.5 1.25C10.2239 1.25 10 1.47386 10 1.75V2.25H6V1.75Z"
            fill="#4C5057"
          />
          <path
            d="M6.15624 9.25C6.15624 9.66421 5.82045 10 5.40624 10C4.99203 10 4.65625 9.66421 4.65625 9.25C4.65625 8.83579 4.99203 8.5 5.40624 8.5C5.82045 8.5 6.15624 8.83579 6.15624 9.25Z"
            fill="#4C5057"
          />
          <path
            d="M8.74997 9.25C8.74997 9.66421 8.41419 10 7.99998 10C7.58577 10 7.24998 9.66421 7.24998 9.25C7.24998 8.83579 7.58577 8.5 7.99998 8.5C8.41419 8.5 8.74997 8.83579 8.74997 9.25Z"
            fill="#4C5057"
          />
          <path
            d="M11.3437 9.25C11.3437 9.66421 11.0079 10 10.5937 10C10.1795 10 9.84371 9.66421 9.84371 9.25C9.84371 8.83579 10.1795 8.5 10.5937 8.5C11.0079 8.5 11.3437 8.83579 11.3437 9.25Z"
            fill="#4C5057"
          />
        </ColorSVGIconBase>
      );
    case 'gray400':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2.25" width="12" height="12" rx="1.5" fill="#E8EAED" />
          <path
            d="M6 1.75C6 1.47386 5.77614 1.25 5.5 1.25C5.22386 1.25 5 1.47386 5 1.75V2.25H3.5C2.67157 2.25 2 2.94324 2 3.79839V6.81445H14V3.79839C14 2.94324 13.3284 2.25 12.5 2.25H11V1.75C11 1.47386 10.7761 1.25 10.5 1.25C10.2239 1.25 10 1.47386 10 1.75V2.25H6V1.75Z"
            fill="#898D94"
          />
          <path
            d="M6.15624 9.25C6.15624 9.66421 5.82045 10 5.40624 10C4.99203 10 4.65625 9.66421 4.65625 9.25C4.65625 8.83579 4.99203 8.5 5.40624 8.5C5.82045 8.5 6.15624 8.83579 6.15624 9.25Z"
            fill="#898D94"
          />
          <path
            d="M8.74997 9.25C8.74997 9.66421 8.41419 10 7.99998 10C7.58577 10 7.24998 9.66421 7.24998 9.25C7.24998 8.83579 7.58577 8.5 7.99998 8.5C8.41419 8.5 8.74997 8.83579 8.74997 9.25Z"
            fill="#898D94"
          />
          <path
            d="M11.3437 9.25C11.3437 9.66421 11.0079 10 10.5937 10C10.1795 10 9.84371 9.66421 9.84371 9.25C9.84371 8.83579 10.1795 8.5 10.5937 8.5C11.0079 8.5 11.3437 8.83579 11.3437 9.25Z"
            fill="#898D94"
          />
        </ColorSVGIconBase>
      );
    case 'orange800':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2.25" width="12" height="12" rx="1.5" fill="#FFD8C2" />
          <path
            d="M6 1.75C6 1.47386 5.77614 1.25 5.5 1.25C5.22386 1.25 5 1.47386 5 1.75V2.25H3.5C2.67157 2.25 2 2.94324 2 3.79839V6.81445H14V3.79839C14 2.94324 13.3284 2.25 12.5 2.25H11V1.75C11 1.47386 10.7761 1.25 10.5 1.25C10.2239 1.25 10 1.47386 10 1.75V2.25H6V1.75Z"
            fill="#FF600C"
          />
          <path
            d="M6.15624 9.25C6.15624 9.66421 5.82045 10 5.40624 10C4.99203 10 4.65625 9.66421 4.65625 9.25C4.65625 8.83579 4.99203 8.5 5.40624 8.5C5.82045 8.5 6.15624 8.83579 6.15624 9.25Z"
            fill="#FF600C"
          />
          <path
            d="M8.74997 9.25C8.74997 9.66421 8.41419 10 7.99998 10C7.58577 10 7.24998 9.66421 7.24998 9.25C7.24998 8.83579 7.58577 8.5 7.99998 8.5C8.41419 8.5 8.74997 8.83579 8.74997 9.25Z"
            fill="#FF600C"
          />
          <path
            d="M11.3437 9.25C11.3437 9.66421 11.0079 10 10.5937 10C10.1795 10 9.84371 9.66421 9.84371 9.25C9.84371 8.83579 10.1795 8.5 10.5937 8.5C11.0079 8.5 11.3437 8.83579 11.3437 9.25Z"
            fill="#FF600C"
          />
        </ColorSVGIconBase>
      );
    case 'white':
      return (
        <ColorSVGIconBase rotate={0} {...props}>
          <rect x="2" y="2.25" width="12" height="12" rx="1.5" fill="white" />
          <path
            d="M6 1.75C6 1.47386 5.77614 1.25 5.5 1.25C5.22386 1.25 5 1.47386 5 1.75V2.25H3.5C2.67157 2.25 2 2.94324 2 3.79839V6.81445H14V3.79839C14 2.94324 13.3284 2.25 12.5 2.25H11V1.75C11 1.47386 10.7761 1.25 10.5 1.25C10.2239 1.25 10 1.47386 10 1.75V2.25H6V1.75Z"
            fill="#E8EAED"
          />
          <path
            d="M6.15624 9.25C6.15624 9.66421 5.82045 10 5.40624 10C4.99203 10 4.65625 9.66421 4.65625 9.25C4.65625 8.83579 4.99203 8.5 5.40624 8.5C5.82045 8.5 6.15624 8.83579 6.15624 9.25Z"
            fill="#E8EAED"
          />
          <path
            d="M8.74997 9.25C8.74997 9.66421 8.41419 10 7.99998 10C7.58577 10 7.24998 9.66421 7.24998 9.25C7.24998 8.83579 7.58577 8.5 7.99998 8.5C8.41419 8.5 8.74997 8.83579 8.74997 9.25Z"
            fill="#E8EAED"
          />
          <path
            d="M11.3437 9.25C11.3437 9.66421 11.0079 10 10.5937 10C10.1795 10 9.84371 9.66421 9.84371 9.25C9.84371 8.83579 10.1795 8.5 10.5937 8.5C11.0079 8.5 11.3437 8.83579 11.3437 9.25Z"
            fill="#E8EAED"
          />
        </ColorSVGIconBase>
      );
    default:
      return null;
  }
};

const ColorSVGIcon = {
  New: NewIcon,
  Close: CloseIcon,
  Pin: PinIcon,
  Arrow: ArrowIcon,
  Profile: ProfileIcon,
  Tooltip: TooltipIcon,
  ToolipBold: TooltipBoldIcon,
  Project: ProjectIcon,
  Reference: ReferenceIcon,
  CopyCheck: CopyCheckIcon,
  Calendar: CalendarIcon,
  Talk: TalkIcon,
  Night: NightIcon,
};

export default ColorSVGIcon;
